export const DATE_FORMAT = "DD/MM/YY"
export const DATE_TIME_FORMAT = "DD/MM/YY h:mm a"
export const DECIMAL_LIMIT = 3
export const ALLOWED_PATHS_WITHOUT_TOKEN = ["/catelogue_request", "/login", "/403"]
export const NON_HEADER_PATHS = ["/catelogue_request"]
export const BUYER_PORTAL_PATHS = ["/catelogue_request", "/buyer-rate-contract", "/consumer-request", "/catelogue-request", "/buyer-order-history", "/buyer-consumer-history", "/buyer_portal_buyer_dashboard", "/buyer-portal-buyer-purchase-order", "/buyer-po-history"]
export const DARK_BACKGROUND_PATHS = ["/tableau-dashboard"]
export const BUYERPO_QTY_TOLERANCE_PERCENTAGE = 5
export const SELLERPO_VP_MIN_PRICE_DIFF = 5
export const SELLER_WEIGHTAGE_APPLICABLE_AMOUNT = 10000
